// extracted by mini-css-extract-plugin
module.exports = {"button":"Moduly_button__2Ya8B","overlay":"Moduly_overlay__19dm5","title":"Moduly_title__2N1dM","x_":"Moduly_x___3cf3D","x":"Moduly_x__2mAZb","title_x":"Moduly_title_x__1-MFT"};